<template>
  <!-- 顶部学生信息（fixed sticky） -->
  <div class="top">
    <van-nav-bar title="课程列表" fixed placeholder />

    <div class="container">
      <div style="height: 10px"></div>
      <div class="student_info">
        <div class="info">
          <div class="btn-group">
            <van-button
              class="changeBtn"
              plain
              size="small"
              type="primary"
              @click="toChild"
              color="#52C1B2"
            >
              切换学生
            </van-button>
          </div>
          <img src="../assets/default_profile.png" />
          <div class="student_desc">
            <span>{{ child_name }}</span>
            <span>{{ school_name }}</span>
            <span>{{ class_name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 功能按钮区 -->
    <div class="action-buttons">
      <van-button type="primary" icon="edit" class="action-btn" @click="enrollCourse">
        报名课程
      </van-button>
      <van-button type="warning" icon="gold-coin-o" class="action-btn" @click="payCourse">
        课程缴费
      </van-button>
    </div>
  </div>

  <!-- 本周课程表 -->
  <div class="timetable-container">
    <div class="timetable-header">
      <span class="timetable-title">课程表</span>
    </div>

    <div class="timetable-wrapper">
      <div class="timetable-body">
        <div v-for="day in weekDays" :key="day.key" class="timetable-row">
          <!-- 左侧日期格 -->
          <div class="timetable-date-cell">
            <span class="weekday-name">{{ day.name }}</span>
          </div>

          <!-- 右侧课程区域 -->
          <div class="course-area">
            <template v-if="getCoursesForDay(day).length > 0">
              <div
                v-for="course in getCoursesForDay(day)"
                :key="course.id"
                class="course-item"
                :class="'type-' + course.course_type"
                @click="toDetail(course)"
              >
                <div class="course-main-row">
                  <span class="course-name">{{ course.title }}</span>
                </div>
                <!-- <div class="course-meta-row" v-if="course.service_class_name">
                  <span class="course-class-name">{{ course.service_class_name }}</span>
                </div> -->
                <div class="course-meta-row" v-if="course.location">
                  <span class="course-location">上课地点: {{ course.location }}</span>
                </div>
                <div class="course-meta-row" v-if="course.service_time">
                  <span class="course-location">上课时间: {{ course.service_time }}</span>
                </div>
              </div>
            </template>
            <div v-else class="no-course">
              <span class="no-course-text">今日无课程</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import api from "../service/api";
import { getAreaType } from "../common/js/utils";

export default {
  setup() {
    const router = useRouter();
    const child_id = ref("");
    const child_name = ref("");
    const school_name = ref("");
    const class_name = ref("");

    // 课程表相关
    const weekDays = ref([
      { name: "周一", key: "星期一" },
      { name: "周二", key: "星期二" },
      { name: "周三", key: "星期三" },
      { name: "周四", key: "星期四" },
      { name: "周五", key: "星期五" },
      { name: "周六", key: "星期六" },
      { name: "周日", key: "星期日" },
    ]);
    const courseMap = ref({}); // key: "星期X" → [course, ...]

    // -------- 工具方法 --------
    const weekKeyMap = {
      周一: "星期一",
      周二: "星期二",
      周三: "星期三",
      周四: "星期四",
      周五: "星期五",
      周六: "星期六",
      周日: "星期日",
    };
    const keyToWeekName = {};
    Object.entries(weekKeyMap).forEach(([k, v]) => {
      keyToWeekName[v] = k;
    });

    function buildCourseMap(result) {
      // result: { "星期一": [...], "星期二": [...], ... }
      courseMap.value = result || {};
    }

    function getCoursesForDay(day) {
      // day 是 weekDays 中的对象，有 key 属性
      const courses = courseMap.value[day.key] || [];
      return courses.map((item) => ({
        id: item.course_id,
        title: item.course_title,
        course_type: item.course_type,
        location: item.location,
        service_class_name: item.service_class_name,
        service_time: item.service_time,
        enrollment_schedule_id: item.enrollment_schedule_id,
      }));
    }

    // -------- 生命周期 --------
    onMounted(() => {
      if (getQuery("child_id")) {
        sessionStorage.setItem("childId", getQuery("child_id"));
        sessionStorage.setItem("childName", getQuery("child_name"));
        sessionStorage.setItem("schoolName", getQuery("school_name"));
        sessionStorage.setItem("className", getQuery("class_name"));
      }
      child_id.value = sessionStorage.getItem("childId");
      child_name.value = sessionStorage.getItem("childName");
      school_name.value = sessionStorage.getItem("schoolName");
      class_name.value = sessionStorage.getItem("className");
      loadCourseMap();
    });

    // -------- 接口：加载课程表数据 --------
    const loadCourseMap = () => {
      api
        .getStudentCourseSchedule({ student_id: child_id.value, type: getAreaType() })
        .then((res) => {
          if (res.data.code == 1001) {
            buildCourseMap(res.data.result || {});
          }
        })
        .catch(() => {});
    };

    // -------- 详情 --------
    // 详情页 getEnrollmentById 只认 enrollment_schedule_id（排课ID），不能用 course_id 兜底
    const toDetail = (course) => {
      if (!course || !course.enrollment_schedule_id) return;
      router.push({
        path: "/enrolledDetail",
        query: { enrollment_schedule_id: course.enrollment_schedule_id },
      });
    };

    const toChild = () => router.push({ path: "/child" });
    const toAllCourses = () => router.push({ path: "/allCourses" });
    const enrollCourse = () => toAllCourses();
    const payCourse = () => router.push({ path: "/payment" });

    function getQuery(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] == variable) return decodeURI(pair[1]);
      }
      return false;
    }

    return {
      child_id,
      child_name,
      school_name,
      class_name,
      weekDays,
      getCoursesForDay,
      toDetail,
      toChild,
      toAllCourses,
      enrollCourse,
      payCourse,
    };
  },
};
</script>

<style lang="less" scoped>
/* ========== 顶部信息区（sticky） ========== */
.top {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #f2f2f2;

  .container {
    height: 140px;
    background-color: #f2f2f2;

    .student_info {
      width: 94%;
      margin: 0 auto;
      height: 120px;
      border-radius: 6px;
      background-color: var(--color-primary);
      box-shadow: 0 2px 8px rgba(82, 193, 178, 0.4);

      .info {
        display: block;
        width: 92%;
        height: 120px;
        margin: 0 auto;
        position: relative;

        .btn-group {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          position: absolute;
          top: 15px;
          right: 0;

          .changeBtn {
            margin-bottom: 8px;
          }
        }

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: inline-block;
          overflow: hidden;
          margin: 30px 0 0 0;
          vertical-align: top;
        }

        .student_desc {
          display: inline-block;
          margin-left: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #fff;
          vertical-align: top;
          margin-top: 30px;

          span {
            display: block;
            color: #fff;
            font-size: 14px;
            padding: 2px 0;
            text-align: left;
          }
        }
      }
    }
  }
}

/* 功能按钮行 */
.action-buttons {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin: 8px 0 0;

  .action-btn {
    flex: 1;
    margin: 0 6px;
    height: 40px;
    font-weight: 500;
    border-radius: 8px;

    :deep(.van-button__icon) {
      margin-right: 4px;
      font-size: 16px;
    }

    &:active {
      opacity: 0.85;
    }
  }
}

/* ========== 本周课程表 ========== */
.timetable-container {
  background-color: #f5f5f5;
  padding: 16px 12px 80px;
}

.timetable-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px 12px;
}

.timetable-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.timetable-week {
  font-size: 12px;
  color: #999;
}

.timetable-wrapper {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
}

.timetable-body {
  display: flex;
  flex-direction: column;
}

.timetable-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

/* 左侧日期格 */
.timetable-date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  background-color: var(--color-primary);
  padding: 14px 8px;
  border-right: 1px solid #4ab3a5;

  .weekday-name {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .weekday-date {
    font-size: 11px;
    opacity: 0.9;
    text-align: center;
    line-height: 1.4;
  }
}

/* 右侧课程区 */
.course-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 6px;
}

/* 课程卡片 */
.course-item {
  position: relative;
  padding: 10px 32px 10px 12px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #52c1b2;
  cursor: pointer;

  &:active {
    opacity: 0.8;
  }

  &.type-1 {
    border-left-color: #ff6b6b;
  }
  &.type-2 {
    border-left-color: #4ecdc4;
  }
  &.type-3 {
    border-left-color: #f7b731;
  }
  &.type-4 {
    border-left-color: #a29bfe;
  }
}

.course-time-row {
  margin-bottom: 3px;

  .course-time {
    font-size: 11px;
    color: var(--color-primary);
  }
}

.course-main-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  .course-name {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 6px;
  }

  .course-type-tag {
    flex-shrink: 0;
    font-size: 10px;
    color: #fff;
    padding: 2px 7px;
    border-radius: 10px;

    &.type-bg-1 {
      background-color: #ff6b6b;
    }
    &.type-bg-2 {
      background-color: #4ecdc4;
    }
    &.type-bg-3 {
      background-color: #f7b731;
    }
    &.type-bg-4 {
      background-color: #a29bfe;
    }
  }
}

.course-meta-row {
  display: flex;
  align-items: center;
  gap: 8px;

  .course-class-name {
    font-size: 12px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .course-location {
    font-size: 11px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .course-price {
    font-size: 12px;
    color: #ff6b35;
    font-weight: 600;
  }

  .course-grade {
    font-size: 11px;
    color: #999;
  }
}

/* 无课程 */
.no-course {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  .no-course-text {
    font-size: 13px;
    color: #ccc;
  }
}

/* 图例 */
.timetable-legend {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
  gap: 14px;

  .legend-item {
    display: flex;
    align-items: center;
  }

  .legend-color {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 5px;
    display: inline-block;

    &.type-bg-1 {
      background-color: #ff6b6b;
    }
    &.type-bg-2 {
      background-color: #4ecdc4;
    }
    &.type-bg-3 {
      background-color: #f7b731;
    }
    &.type-bg-4 {
      background-color: #a29bfe;
    }
  }

  .legend-text {
    font-size: 12px;
    color: #666;
  }
}
</style>
